// Module
var code = `<breadcrumbs></breadcrumbs>
<section class="box">
  <sub-header header="\$ctrl.depositAccountType.productDefinition.productName  || 'Create new'"></sub-header>

  <div class="tab-menu">
    <ul class="nav-tabs">
      <li
        ng-click="\$ctrl.sectionType = 'general'"
        ng-class="{
          'active': \$ctrl.sectionType === 'general'
        }">
        <a><i ng-if="\$ctrl.generalForm.\$invalid" class="icon icon-warning-sign"></i>
        General</a>
      </li>
      <li
        ng-click="\$ctrl.sectionType = 'interest'"
        ng-class="{
          'active': \$ctrl.sectionType === 'interest'
        }">
        <a><i ng-if="\$ctrl.interestBoardsForm.\$invalid" class="icon icon-warning-sign"></i>
        Interests</a>
      </li>
      <li
        ng-click="\$ctrl.sectionType = 'charges'"
        ng-class="{
          'active': \$ctrl.sectionType === 'charges'
        }">
        <a><i ng-if="\$ctrl.chargesForm.\$invalid" class="icon icon-warning-sign"></i>
        Fees and charges</a>
      </li>
      <li
        ng-click="\$ctrl.sectionType = 'customFees'"
        ng-class="{
          'active': \$ctrl.sectionType === 'customFees'
        }">
        <a><i ng-if="\$ctrl.customFeesForm.\$invalid" class="icon icon-warning-sign"></i>
        Custom fees</a>
      </li>
      <li
        ng-click="\$ctrl.sectionType = 'advanced'"
        ng-class="{
          'active': \$ctrl.sectionType === 'advanced'
        }">
        <a><i ng-if="\$ctrl.advancedForm.\$invalid" class="icon icon-warning-sign"></i>
        Advanced</a>
      </li>
      <li
        ng-click="\$ctrl.sectionType = 'automatic_debit_agreement'"
        ng-class="{
          'active': \$ctrl.sectionType === 'automatic_debit_agreement'
        }">
        <a><i ng-if="\$ctrl.automaticDebitAgreementForm.\$invalid" class="icon icon-warning-sign"></i>
        Automatic debit agreement</a>
      </li>
      <li
        ng-if="\$ctrl.transactionLimitAvailable()"
        ng-click="\$ctrl.sectionType = 'transaction_limits'"
        ng-class="{
          'active': \$ctrl.sectionType === 'transaction_limits'
        }">
        <a><i ng-if="\$ctrl.transactionLimitsForm.\$invalid" class="icon icon-warning-sign"></i>
        Transaction limits</a>
      </li>
      <li ng-if="\$ctrl.depositAccountType.id"
          ng-click="\$ctrl.sectionType = 'mappings'"
          ng-class="{
          'active': \$ctrl.sectionType === 'mappings'
        }">
        <a><i ng-if="\$ctrl.glMappingsForm.\$invalid" class="icon icon-warning-sign"></i>
        GL mappings</a>
      </li>
      <li ng-if="!\$ctrl.depositAccountType.id" class="disabled"><a>GL mappings</a></li>
    </ul>
  </div>


<form name="\$ctrl.mainForm">

  <deposit-account-section
    account-type="\$ctrl.depositAccountType"
    section-type="\$ctrl.sectionType"
    general-form="\$ctrl.generalForm"
    charges-form="\$ctrl.chargesForm"
    transaction-limits-form="\$ctrl.transactionLimitsForm"
    branches="\$ctrl.branches">
  </deposit-account-section>

  <div class="term-deposit-section" ng-show="\$ctrl.sectionType === 'interest'">

    <div class="alert">
      Please note: In case of duplicated or missing rows default interest rate will be used for calculation
    </div>

    <ng-form name="\$ctrl.interestBoardsForm">
      <interest-board ng-repeat="board in \$ctrl.depositAccountType.interestBoards" board="board">
      </interest-board>
    </ng-form>
  </div>

  <div class="term-deposit-section" ng-show="\$ctrl.sectionType === 'customFees'">
    <deposit-account-fees
      account-product="\$ctrl.depositAccountType"
      ng-if="\$ctrl.depositAccountType"
      form="\$ctrl.customFeesForm">
    </deposit-account-fees>
  </div>

  <div class="term-deposit-section" ng-show="\$ctrl.sectionType === 'advanced'">
    <deposit-account-advanced
      account-product="\$ctrl.depositAccountType"
      ng-if="\$ctrl.depositAccountType"
      form="\$ctrl.advancedForm">
    </deposit-account-advanced>
  </div>

  <div class="term-deposit-section" ng-show="\$ctrl.sectionType === 'automatic_debit_agreement'">
    <deposit-account-ada-configuration
      account-type="\$ctrl.depositAccountType"
      form="\$ctrl.automaticDebitAgreementForm">
    </deposit-account-ada-configuration>
  </div>

  <div class="term-deposit-section" ng-show="\$ctrl.sectionType === 'transaction_limits'">
    <form name="\$ctrl.transactionLimitsForm">
      <div class="form-column">
        <transaction-quota
          quota-title="'Agency Banking'"
          quotas="\$ctrl.depositAccountType.transactionQuota">
        </transaction-quota>
      </div>
    </form>
  </div>

  <div class="term-deposit-section" ng-show="\$ctrl.sectionType === 'mappings'">
    <ng-form name = "\$ctrl.glMappingsForm">
      <gl-mappings
        ng-if="\$ctrl.depositAccountType.id"
        custom-fees="\$ctrl.depositAccountType.feeDefinitions"
        product-type="\$ctrl.depositAccountType.productDefinition"
        instance-ready="\$ctrl.setGlMappingComponent(instance)">
      </gl-mappings>
    </ng-form>
  </div>

  <div class="clearfix"></div>
  <div class="buttons"
       ng-if="!\$ctrl.originalDepositAccount.productDefinition.expired
              && !\$ctrl.chargesForm.wizardMode && !\$ctrl.customFeesForm.wizardMode">
    <button
      class="btn btn-warning"
      ng-click="\$ctrl.cancelChanges()">
      Cancel
    </button>

    <button
      type="submit"
      class="btn btn-primary"
      ng-disabled="\$ctrl.mainForm.\$invalid || \$ctrl.glMappingsForm.\$invalid"
      ng-click="\$ctrl.saveDeposit()">
      Save
    </button>
  </div>

</form>
</section>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/administration/deposit-account/details/deposit-account-details.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;